/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import { MUNI_STATES_AND_TERRITORIES, getId } from '../../twd/twd'

export default () => {

    let [state, setState] = useState('')
    useEffect(() => {
        let e = document.getElementById(`municipal-map-${state}`)
        if (!e) return
        e.dispatchEvent(new MouseEvent('mouseover', { bubbles: true}))
    }, [state])

    let id = getId()
    return <React.Fragment>
        <label htmlFor={id}>Browse by State</label>
        <div className="select-wrapper">
        <select
            id={id}
            data-name="municipals-scatter-graph-active-state"
            className="form-control"
            value={state}
            onChange={(e) => {
                let a = e.target.value
                setState(a)
            }}
        >
        {
            [{
                label: 'All',
                value: ''
            }]
            .concat(MUNI_STATES_AND_TERRITORIES)
            .map((a, i) => {
                let s = (a.value.split('=')[1] || '')
                return <option key={i} value={s}>{a.label}</option>
            })
        }
        </select>
        </div>
        </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/municipals/map/active-state.js